import { PersonnelService } from "@/common/api.service";
import Vue from "vue";
import { CANCEL_PERSON_COURSE_EDIT_STATE, DELETE_PERSON_COURSE, DELETE_PERSON_COURSE_BY_PERSON_ID, FETCH_PERSON_COURSE_LIST, FETCH_PERSON_COURSE_LIST_BY_ID, SAVE_EDITED_PERSON_COURSE, SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID, SAVE_NEW_PERSON_COURSE, SAVE_NEW_PERSON_COURSE_BY_PERSON_ID, UPDATE_PERSON_COURSE } from "./actions.js";
import {
    FETCH_PERSON_COURSES_END,
    FILTER_COURSES,
    FILTER_PERSON_COURSE_LIST_BY_COURSE_TYPE,
    FILTER_PERSON_COURSE_LIST_BY_PERSON_ID,
    LOAD_PERSON_COURSE_TO_EDIT,
    RESET_DEFAULT_COURSE_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_COURSE,
    RESET_DEFAULT_PERSON_COURSE_TO_EDIT,
    TOGGLE_EDIT_PERSON_COURSE_DIALOG,
    TOGGLE_NEW_PERSON_COURSE_DIALOG,
    TOGGLE_PERSON_COURSE_EDIT_STATE,
    UPDATE_ADD_PERSON_COURSE_FIELD,
    UPDATE_EDIT_PERSON_COURSE_FIELD,
    UPDATE_NEW_PERSON_COURSE
} from "./mutations.js";

import { SET_TOASTER_MESSAGE } from "../this_app/mutations.js";

const functions = {

    // sort on key values
    sortString(key,desc) {
        return function(a,b){
            // console.log(a);
            // console.log(b);
            return desc ? ~~(a[key] < b[key]) : ~~(a[key] > b[key]);
        }
    },

    compareStringsDesc(a, b) {
        // Use toUpperCase() to ignore character casing
        const stringA = moment(a.string);
        const stringB = moment(b.string);

        let comparison = 0;
        if (stringA.isAfter(stringB)) {
            comparison = -1;
        } else if (stringA.isBefore(stringB)) {
            comparison = -0;
        }
        return comparison;
    },
    compareStringsAsc(a, b) {
        // Use toUpperCase() to ignore character casing
        const stringA = moment(a.string);
        const stringB = moment(b.string);

        let comparison = -1;
        if (stringA.isAfter(stringB)) {
            comparison = -0;
        } else if (stringA.isBefore(stringB)) {
            comparison = -1;
        }
        return comparison;
    }
};

const state = {
    personCourseList: [],
    editPersonCourse: {
        title: '',
        description: '',
        personId: undefined,
        courseTypeId: undefined,
        startDate: undefined,
        endDate: undefined,
        renewalDate: undefined,
        comments: undefined
    },
    addPersonCourse: {
        title: '',
        description: '',
        personId: undefined,
        courseTypeId: undefined,
        startDate: undefined,
        endDate: undefined,
        renewalDate: undefined,
        comments: undefined
    },
    editPersonCourseDialog: false,
    addPersonCourseDialog: false,
    courseTableSearch: "",
    filterPersonCourseListByCourseType: "",
    filterPersonCourseListByPersonId: "",
};

const getDefaultState = () => {
    return {
        defaultPersonCourse: {
            title: '',
            description: '',
            courseTypeId: undefined,
            startDate: undefined,
            endDate: undefined,
            renewalDate: undefined,
            comments: undefined
        },
    }
};

const getters = {
    courseTableSearch(state){
        return state.courseTableSearch;
    },
    addPersonCourseDialog(state) {
        return state.addPersonCourseDialog;
    },
    editPersonCourseDialog(state) {
        return state.editPersonCourseDialog;
    },
    personCourseList(state) {
        return state.personCourseList;
    },

    personCourseListForTable(state, getters) {
        let filteredPersonCourseList = state.personCourseList;
        if (state.filterPersonCourseListByCourseType != '') {
            filteredPersonCourseList = filteredPersonCourseList.filter(function (itm) {
                if (itm.courseTypeId) {
                    return state.filterPersonCourseListByCourseType.includes(itm.courseTypeId);
                }
            });
        }

        if (state.filterPersonCourseListByPersonId != '') {
            filteredPersonCourseList = filteredPersonCourseList.filter(function (itm) {
                if (itm.personId) {
                    return state.filterPersonCourseListByPersonId.includes(itm.personId);
                }
            });
        }

        if (state.filterPersonCourseListByCourseStatus != '') {
            filteredPersonCourseList = filteredPersonCourseList.filter(function (itm) {
                return state.filterPersonCourseListByCourseStatus.includes(itm.courseStatusId);
            });
        }

        filteredPersonCourseList.forEach(function (item, key) {

            let personName = getters.getPersonNameById(item.personId);

            if (personName == undefined) {
                personName = "Not Assigned"
            }

            filteredPersonCourseList[key]['personName'] = personName;
        });

        filteredPersonCourseList.forEach(function (item, key) {
            let courseTypeName = getters.getCourseTypeNameById(item.courseTypeId);

            if (courseTypeName == undefined) {
                courseTypeName = "Not Defined"
            }

            filteredPersonCourseList[key]['courseTypeName'] = courseTypeName;
        });

        filteredPersonCourseList.forEach(function (item, key) {
            let courseStatusName = getters.getCourseStatusNameById(item.courseStatusId);

            if (courseStatusName == undefined) {
                courseStatusName = "Not Defined"
            }

            filteredPersonCourseList[key]['courseStatusName'] = courseStatusName;
        });


        return filteredPersonCourseList;
    },

    personCourseListSorted(state, sortOrder) {
        // `this` points to the vm instance
        let frozenCourseList = Object.freeze(state.personCourseList);
        let jsonedCourseList = JSON.parse(JSON.stringify(frozenCourseList));
        return jsonedCourseList.sort(functions.sortString('name', sortOrder));
    },
    editStateCourse(state) {
        return state.editStateCourse;
    },
};

const actions = {
    [FETCH_PERSON_COURSE_LIST]({commit}) {
        return PersonnelService.getAllPersonCourses()
            .then(({data}) => {
                commit(FETCH_PERSON_COURSES_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch course list'});
            });
    },
    [FETCH_PERSON_COURSE_LIST_BY_ID]({commit}, personId) {
        return PersonnelService.getPersonCourses(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_COURSES_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch course list'});
            });
    },
    [CANCEL_PERSON_COURSE_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, params.personId);
        commit(TOGGLE_PERSON_COURSE_EDIT_STATE, params.field);
    },
    [SAVE_NEW_PERSON_COURSE_BY_PERSON_ID]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonCourse = state.addPersonCourse;
        const personId = state.addPersonCourse.personId;
        return PersonnelService.savePersonCourse(newPersonCourse)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to save'});
            });
    },
    [SAVE_NEW_PERSON_COURSE]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonCourse = state.addPersonCourse;
        return PersonnelService.savePersonCourse(newPersonCourse)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_COURSE_LIST);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to save'});
            });
    },

    [SAVE_EDITED_PERSON_COURSE]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonCourse = state.editPersonCourse;
        return PersonnelService.updatePersonCourse(editedPersonCourse)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_COURSE_TO_EDIT);
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, editedPersonCourse.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to update'});
            });
    },
    [SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonCourse = state.editPersonCourse;
        return PersonnelService.updatePersonCourse(editedPersonCourse)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_COURSE_TO_EDIT);
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, editedPersonCourse.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to update'});
            });
    },
    [UPDATE_PERSON_COURSE]({commit, dispatch}, params) {
        return PersonnelService.updatePersonCourse(state.editPersonCourse)
            .then(({data}) => {
                commit(RESET_DEFAULT_COURSE_TO_EDIT);
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to update'});
            });
    },

    [DELETE_PERSON_COURSE]({commit, dispatch}, params) {
        return PersonnelService.deletePersonCourse(params.id)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to delete'});
            });
    },

    [DELETE_PERSON_COURSE_BY_PERSON_ID]({commit, dispatch}, params) {
        return PersonnelService.deletePersonCourse(params.id)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_COURSE_LIST_BY_ID, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Course failed to delete'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FILTER_COURSES](state, value) {
        state.courseTableSearch = value;
    },
    [FILTER_PERSON_COURSE_LIST_BY_COURSE_TYPE](state, value) {
        state.filterPersonCourseListByCourseType = value;
    },
    [FILTER_PERSON_COURSE_LIST_BY_PERSON_ID](state, value) {
        state.filterPersonCourseListByPersonId = value;
    },
    [TOGGLE_NEW_PERSON_COURSE_DIALOG](state) {
        state.addPersonCourseDialog = !state.addPersonCourseDialog;
    },
    [TOGGLE_EDIT_PERSON_COURSE_DIALOG](state) {
        state.editPersonCourseDialog = !state.editPersonCourseDialog;
    },
    [RESET_DEFAULT_NEW_PERSON_COURSE](state, personId) {
        state.addPersonCourse = getDefaultState().defaultPersonCourse;
        state.addPersonCourse.personId = personId;
    },
    [RESET_DEFAULT_PERSON_COURSE_TO_EDIT](state) {
        state.editPersonCourse = getDefaultState().defaultPersonCourse;
    },
    [LOAD_PERSON_COURSE_TO_EDIT](state, id) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personCourseList.find((list) =>
            list.id == id);
        state.editPersonCourse = itemToEdit;
    },
    [TOGGLE_PERSON_COURSE_EDIT_STATE](state, field) {
        state.editStateCourse[field] = !state.editStateCourse[field];
    },
    [UPDATE_EDIT_PERSON_COURSE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonCourse[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonCourse[data.key] = data.value;
        }
    },
    [UPDATE_ADD_PERSON_COURSE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonCourse[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonCourse[data.key] = data.value;
        }
    },
    [FETCH_PERSON_COURSES_END](state, data) {
        state.personCourseList = data;
        state.isLoading = false;
    },
    [UPDATE_NEW_PERSON_COURSE](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonCourse[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonCourse[data.key] = data.value;
        }
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
